var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-down';
                    var viewUrl = 'sprite.svg#view-icon-arrow-down';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-arrow-down#icon-arrow-down';
                            viewUrl = 'sprite.svg?icon-arrow-down#view-icon-arrow-down';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 9.9 6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };